// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import loadSolidGauge from 'highcharts/modules/solid-gauge'
import loadHighchartsMore from 'highcharts/highcharts-more'


const vueConfig = require('vue-config')
const configs = {
  API: 'https://api-vtrleld.vtc.systems', // It's better to require a config file
  // API: 'http://staging.api.vtc.systems' ,// It's better to require a config file
  // API: 'http://192.168.0.99:8080', // It's better to require a config file
  // API: 'http://localhost:8080', // It's better to require a config file
  loading: false,
  MapsAPI: false
}

loadHighchartsMore(Highcharts)
loadSolidGauge(Highcharts)

Vue.use(VueHighcharts, { Highcharts })
Vue.config.productionTip = false
Vue.use(vueConfig, configs)

/*
  Vue filter to Capitalize initial letter.
*/
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js